export const paths = {
  home: '/',
  profile: '/perfil',
  signup: '/registro',
  receivedAccessRequests: '/solicitudes-de-acceso',
  dossierExplorer: '/explorador',
  sharedDigitalDossier: '/explorador/:uuid',
  cropPledge: '/prendas-de-cultivo',
  cropPledgeDetail: '/prendas-de-cultivo/:uuid',
} as const;

export type RouteKey = keyof typeof paths;
